import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCloudUpload = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 16,
	viewBox: "0 0 24 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M19.355 6.036C18.674 2.595 15.641 0 12 0C9.108 0 6.603 1.639 5.352 4.036C2.343 4.36 0 6.906 0 10C0 13.314 2.686 16 6 16H19C21.761 16 24 13.761 24 11C24 8.36 21.948 6.221 19.355 6.036ZM12 4L17 9H14V13H10V9H7L12 4Z",
		fill: "#051336"
	})
});
export default SvgCloudUpload;
